import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import Portfolio from "./components/portfolio/Portfolio";
import About from "./components/about/About";
import Career from "./components/career/Career";
import Experience from "./components/experience/Experience";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";

export default function App() {
  return (
    <>
      <Header />
      <Nav />
      <main>
        <Portfolio />
        <About />
        <Career />
        <Experience />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
